var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    { staticClass: "tip", attrs: { placement: "top", "popper-class": "tip" } },
    [
      _c("div", {
        attrs: { slot: "content", placement: "top-start" },
        domProps: { innerHTML: _vm._s(_vm.tipContent) },
        slot: "content",
      }),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("../../assets/icons/i_tip.svg"), alt: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }